<template>
  <div>
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="特定商取引法に基づく表記" />
    <table class="common-table tradelaw-table">
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <th>{{ item.th }}</th>
          <td>{{ item.td }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import Breadcrumb from '@/components/modules/Breadcrumb'
export default {
  components: {
    HeaderBanner,
    Breadcrumb,
  },
  title: '特定商取引に基づく表記｜B-Call（ビーコール）',
  data() {
    return {
      items: [
        { th: '販売社名', td: `株式会社ビーアッサ` },
        { th: 'サイト店舗名', td: `B-Call(ビーコール)` },
        { th: '運営統括責任者', td: `浅山 豊樹 (アサヤマ トヨキ)` },
        {
          th: '本社：所在地',
          td: '〒922-0101 石川県加賀市山中温泉中田町ハ-101',
        },
        {
          th: '営業所：所在地',
          td: '〒921-8811 石川県野々市市高橋町10-18',
        },
        { th: '電話/ FAX 番号', td: `TEL.076-294-4440 / FAX.076-294-4432` },
        { th: 'メールアドレス', td: `info@b-call.jp` },
        { th: '販売 URL', td: `https://b-call.jp` },
        {
          th: 'お支払い方法',
          td: `●銀行振込み(前払い) ●法人掛け払い ●クレジットカード払い ●代金引換`,
        },
        {
          th: '商品代金以外の必要金額',
          td: `●銀行振込手数料 ●代引き手数料:当社で負担いたします。
              ●送料:国内に限り、当社で負担いたします。`,
        },
        { th: '販売数量', td: `1個から` },
        {
          th: 'お申込み有効期限',
          td: `7日以内にお願いいたします。
          ※7日を越えた場合は、無効とさせていただきます。`,
        },
        {
          th: '商品引渡し時期',
          td: `銀行振込みの場合、入金確認後3営業日以内で発送致します。
              クレジットカード払い・代金引換の場合、ご注文確定後3日営業日以内で発送致します。
              法人掛け払いの場合、審査・ご注文確定後3日営業日以内で発送致します。
              ※欠品及びお届けまでに日数を要する場合は、当社よりご連絡させていただきます。`,
        },
        { th: '商品引渡し方法', td: `当方にて手配後、運送会社による配送` },
        {
          th: '返品・不良品について',
          td: `「不良品・当社の商品の間違え」の場合は当社が負担いたします。
                送料・手数料ともに弊社負担で早急に新品をご送付致します。
                【返品対象】「不良品・当社の商品の間違え」の場合
                【返品時期】商品到着後8日以内に弊社までご連絡下さい。
                【返品方法】送料着払いにてご返品下さい。
                ※お客様の都合による返品は、原則お受けできません。`,
        },
        {
          th: '特記事項',
          td: `海外からのご注文・海外への発送は受け付けておりません。`,
        },
      ],
    }
  },
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベル・チャイム（ワイヤレス）の専門店ならB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: '特定商取引法に基づく表記',
            path: 'https://b-call.jp/tradelaw',
          },
        ],
      }
    },
  },
}
</script>

<style>
.tradelaw-table td {
  width: 700px;

  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Tradelaw.vue